export default {
    user: { user: null },
    settings: {
        loading: false,
        alert: { alert: false, message: null, title: null, notification: null },
        theme: 'light',
    },
    enrollment: {
        productId: null,
        productType: null
    },
    courseCurriculum: {
        curriculums: {},
        loading: false,
        error: null
    }
}
